import { Button, Container, Form } from 'react-bootstrap';
import Banner from '../../Component/Banner';
import { useNavigate } from 'react-router-dom';

const PrimEnd = () => {
    const navigate = useNavigate()

    const startQuiz = (e) => {
        e.preventDefault();
        navigate('/QuizTrivias/June2026/primscoreboard')
    }

    return (
        <>
            <Container className="keiki-party prim-7th">
            <div className='fontBackground'>
                <Banner caption="THANK YOU!"/>
            </div> 
            <div className='text-center'>
                <div className='Apps'>
                <div className="prim-results-card">
                    <h1 className="prim-score">
                        Score: {sessionStorage.getItem('PrimTriviaScore')} / 10
                    </h1>

                    <h2 className="prim-time">
                        ⏱ Time: {sessionStorage.getItem('PrimTriviaTime')} seconds
                    </h2>
                </div>
                
                <h2 className="prim-section-title">Questions</h2>

                <div className="prim-question-card">What is Primrose’s full name?</div>
                <div className="prim-question-card">When is Primrose’s birthday?</div>
                <div className="prim-question-card">Where was she born?</div>
                <div className="prim-question-card">What does she currently want to be when she grows up?</div>
                <div className="prim-question-card">She just finished first grade in Ogden, Utah, what is the school name?</div>
                <div className="prim-question-card">She recently placed 4th in a contest. What is the category?</div>
                <div className="prim-question-card">What are her top 2 favorite foods?</div>
                <div className="prim-question-card">What is her nickname?</div>
                <div className="prim-question-card">What is her favorite color?</div>
                <div className="prim-question-card">What is her favorite song?</div>
                <Form onSubmit={startQuiz}>
                    <br />
                    <div className='row'>
                        <div className='col'>
                        </div>
                        <div className='col align-self-center fontBackground'>
                        <Button
                            type="submit"
                            className="prim-scoreboard-btn"
                        >
                            Go to Scoreboard
                        </Button>
                        </div>
                        <div className='col'>
                        </div>
                        <br />
                    </div>
                </Form>
                </div>
            </div>
            </Container>
        </>
    )
}

export default PrimEnd;